import React from 'react';
import IdeateWrapper from '../components/IdeateWrapper';

const IndexPage = () => <IdeateWrapper />;

export default IndexPage;
